// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"47da2e3c","952":"cdb3eb17"}[chunkId] + ".chunk.js";
};